import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs, redirect } from 'react-router';
import {
  isStaffPermissionEnabled,
  staffQueryFn,
  staffQueryKey,
} from '~/hooks/queries/useStaffQuery/useStaffQuery';
import { perms } from './perms';
import { requirePerm } from './requirePerm';

/**
 * Staff Client Manager routes — Dianomi login plus `client|admin` from staff.pl
 * (same gate as the Client sidebar section).
 */
export const staffClientPermsLoader = (queryClient: QueryClient) => {
  return async (args: LoaderFunctionArgs) => {
    await requirePerm(perms.isDianomi)(args);
    const staffData = await queryClient.ensureQueryData({
      queryKey: staffQueryKey,
      queryFn: staffQueryFn,
    });
    if (
      !isStaffPermissionEnabled(staffData.permissions.admin) &&
      !isStaffPermissionEnabled(staffData.permissions.client)
    ) {
      throw redirect('/forbidden');
    }
    return staffData;
  };
};
